export enum TIME_CATEGORIES {
  DEFAULT = 'timeCategory',
  FIRST = 'timeCategory1Id',
  SECOND = 'timeCategory2Id'
};
  